export default __webpack_public_path__ + "static/media/seasnol img.0602a0d8.png";